// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CountryCollaboratorList_container__Pe5M2 {
  width: 100%;
  position: absolute;
  bottom: 0;
  font-family: "Roboto", sans-serif;
}

.CountryCollaboratorList_main-content__y1wi8 {
  padding: 24px;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.CountryCollaboratorList_header__VWok7 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px !important;
}

.CountryCollaboratorList_title-container__hdDi6 {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
}

.CountryCollaboratorList_title__uo17C {
  color: var(--explore-color) !important;
}

.CountryCollaboratorList_menu-button__BS5CY {
  background-color: var(--explore-color) !important;
  margin-right: 8px !important;
}

.CountryCollaboratorList_keywords-title__1495s {
  margin-top: 16px !important;
  margin-bottom: 8px !important;
  font-weight: 500 !important;
}

.CountryCollaboratorList_keywords-container__jBNsj {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 4px;
  margin-top: 8px !important;
}

.CountryCollaboratorList_drawer__UOagY {
  width: 100%;
  z-index: 1301 !important;
}

.CountryCollaboratorList_drawer-paper__VypeL {
  width: 550px;
  padding: 0;
  overflow: hidden;
}

.CountryCollaboratorList_drawer-container__6Gb5w {
  height: 100%;
  overflow-y: auto;
}

.CountryCollaboratorList_drawer-header__Uc-qa {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background-color: #f5f5f5;
  position: sticky;
  top: 0;
  z-index: 1;
}

.CountryCollaboratorList_close-button__6zJCl {
  padding: 8px;
}

.CountryCollaboratorList_drawer-content__VT3jF {
  padding: 16px;
}

.CountryCollaboratorList_affiliations-list__HO3SZ {
  padding: 0;
}

.CountryCollaboratorList_affiliation-item__arREd {
  padding: 16px;
  flex-direction: column !important;
  align-items: initial !important;
}

.CountryCollaboratorList_affiliation-item-header__4gCs0 {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
}

.CountryCollaboratorList_school-icon__9KIqo {
  margin-right: 16px !important;
  color: var(--explore-color);
}

.CountryCollaboratorList_keywords-badge__NsslO {
  margin-left: 8px !important;
}

.CountryCollaboratorList_keywords-chip__PMmn- {
  height: 24px;
}

.CountryCollaboratorList_affiliation-details__dipM5 {
  padding: 24px 16px;
}

.CountryCollaboratorList_detail-header__OathY {
  display: flex;
  align-items: center;
  margin-bottom: 16px !important;
}

.CountryCollaboratorList_detail-icon__NkLkH {
  font-size: 32px;
  margin-right: 12px !important;
  color: var(--explore-color);
}

.CountryCollaboratorList_detail-title__d0VbB {
  font-weight: 500 !important;
  color: var(--explore-color) !important;
}

.CountryCollaboratorList_pub-count__P0NsM {
  margin-bottom: 16px !important;
  font-weight: 500 !important;
}

.CountryCollaboratorList_keywords-subtitle__PHo3r {
  margin-top: 16px !important;
  margin-bottom: 8px !important;
  font-weight: 500 !important;
}

.CountryCollaboratorList_detail-keywords__YXyEV {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 4px;
}

.CountryCollaboratorList_back-button__NwzIu {
  margin-top: 16px !important;
  position: sticky !important;
  bottom: 24px;
  background-color: #fff !important;
}

.CountryCollaboratorList_pub-count-chip__EI0kc {
  margin-left: auto;
}

.CountryCollaboratorList_section-title__yJhNR {
  font-weight: 500 !important;
  color: var(--explore-color);
}

.CountryCollaboratorList_collab-list__Zl73t {
  padding: 0;
  margin-bottom: 16px;
}

.CountryCollaboratorList_collab-item__sC-N0 {
  padding: 12px 0;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #eaeaea;
}

.CountryCollaboratorList_collab-avatar__9hETo {
  width: 48px;
  height: 48px;
  margin-right: 16px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #e0e0e0;
}

.CountryCollaboratorList_researcher-photo__TppiL,
.CountryCollaboratorList_unit-logo__z88VV {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.CountryCollaboratorList_avatar-placeholder__TPG0a {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #1976d2;
  color: white;
  font-size: 20px;
  font-weight: bold;
}

@media (max-width: 1024px) {
  .CountryCollaboratorList_container__Pe5M2 {
    width: 100%;
    padding: 0 16px;
  }
  .CountryCollaboratorList_drawer-paper__VypeL {
    width: 300px;
  }
}
@media (max-width: 480px) {
  .CountryCollaboratorList_header__VWok7 {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
  .CountryCollaboratorList_drawer-paper__VypeL {
    width: 100dvw;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Components/InternationalCollaboratorMap/CountryCollaboratorList.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,iCAAA;AACF;;AAEA;EACE,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,wCAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,8BAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,QAAA;AACF;;AAEA;EACE,sCAAA;AACF;;AAEA;EACE,iDAAA;EACA,4BAAA;AACF;;AAEA;EACE,2BAAA;EACA,6BAAA;EACA,2BAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,0BAAA;AACF;;AAEA;EACE,WAAA;EACA,wBAAA;AACF;;AAEA;EACE,YAAA;EACA,UAAA;EACA,gBAAA;AACF;;AAEA;EACE,YAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,aAAA;EACA,iCAAA;EACA,+BAAA;AACF;;AAEA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AACF;;AAEA;EACE,6BAAA;EACA,2BAAA;AACF;;AAEA;EACE,2BAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AACF;;AAEA;EACE,eAAA;EACA,6BAAA;EACA,2BAAA;AACF;;AAEA;EACE,2BAAA;EACA,sCAAA;AACF;;AAEA;EACE,8BAAA;EACA,2BAAA;AACF;;AAEA;EACE,2BAAA;EACA,6BAAA;EACA,2BAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;EACA,YAAA;AACF;;AAEA;EACE,2BAAA;EACA,2BAAA;EACA,YAAA;EACA,iCAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,2BAAA;EACA,2BAAA;AACF;;AAEA;EACE,UAAA;EACA,mBAAA;AACF;;AAEA;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,gCAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;AACF;;AAEA;;EAEE,WAAA;EACA,YAAA;EACA,iBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;AACF;;AAEA;EACE;IACE,WAAA;IACA,eAAA;EACF;EAEA;IACE,YAAA;EAAF;AACF;AAGA;EACE;IACE,sBAAA;IACA,uBAAA;IACA,SAAA;EADF;EAIA;IACE,aAAA;EAFF;AACF","sourcesContent":[".container {\n  width: 100%;\n  position: absolute;\n  bottom: 0;\n  font-family: \"Roboto\", sans-serif;\n}\n\n.main-content {\n  padding: 24px;\n  background-color: #f9f9f9;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px !important;\n}\n\n.title-container {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.title {\n  color: var(--explore-color) !important;\n}\n\n.menu-button {\n  background-color: var(--explore-color) !important;\n  margin-right: 8px !important;\n}\n\n.keywords-title {\n  margin-top: 16px !important;\n  margin-bottom: 8px !important;\n  font-weight: 500 !important;\n}\n\n.keywords-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px 4px;\n  margin-top: 8px !important;\n}\n\n.drawer {\n  width: 100%;\n  z-index: 1301 !important;\n}\n\n.drawer-paper {\n  width: 550px;\n  padding: 0;\n  overflow: hidden;\n}\n\n.drawer-container {\n  height: 100%;\n  overflow-y: auto;\n}\n\n.drawer-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px;\n  background-color: #f5f5f5;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\n.close-button {\n  padding: 8px;\n}\n\n.drawer-content {\n  padding: 16px;\n}\n\n.affiliations-list {\n  padding: 0;\n}\n\n.affiliation-item {\n  padding: 16px;\n  flex-direction: column !important;\n  align-items: initial !important;\n}\n\n.affiliation-item-header {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.school-icon {\n  margin-right: 16px !important;\n  color: var(--explore-color);\n}\n\n.keywords-badge {\n  margin-left: 8px !important;\n}\n\n.keywords-chip {\n  height: 24px;\n}\n\n.affiliation-details {\n  padding: 24px 16px;\n}\n\n.detail-header {\n  display: flex;\n  align-items: center;\n  margin-bottom: 16px !important;\n}\n\n.detail-icon {\n  font-size: 32px;\n  margin-right: 12px !important;\n  color: var(--explore-color);\n}\n\n.detail-title {\n  font-weight: 500 !important;\n  color: var(--explore-color) !important;\n}\n\n.pub-count {\n  margin-bottom: 16px !important;\n  font-weight: 500 !important;\n}\n\n.keywords-subtitle {\n  margin-top: 16px !important;\n  margin-bottom: 8px !important;\n  font-weight: 500 !important;\n}\n\n.detail-keywords {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px 4px;\n}\n\n.back-button {\n  margin-top: 16px !important;\n  position: sticky !important;\n  bottom: 24px;\n  background-color: #fff !important;\n}\n\n.pub-count-chip {\n  margin-left: auto;\n}\n\n.section-title {\n  font-weight: 500 !important;\n  color: var(--explore-color);\n}\n\n.collab-list {\n  padding: 0;\n  margin-bottom: 16px;\n}\n\n.collab-item {\n  padding: 12px 0;\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid #eaeaea;\n}\n\n.collab-avatar {\n  width: 48px;\n  height: 48px;\n  margin-right: 16px;\n  border-radius: 50%;\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #e0e0e0;\n}\n\n.researcher-photo,\n.unit-logo {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.avatar-placeholder {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #1976d2;\n  color: white;\n  font-size: 20px;\n  font-weight: bold;\n}\n\n@media (max-width: 1024px) {\n  .container {\n    width: 100%;\n    padding: 0 16px;\n  }\n\n  .drawer-paper {\n    width: 300px;\n  }\n}\n\n@media (max-width: 480px) {\n  .header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n  }\n\n  .drawer-paper {\n    width: 100dvw;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CountryCollaboratorList_container__Pe5M2`,
	"main-content": `CountryCollaboratorList_main-content__y1wi8`,
	"header": `CountryCollaboratorList_header__VWok7`,
	"title-container": `CountryCollaboratorList_title-container__hdDi6`,
	"title": `CountryCollaboratorList_title__uo17C`,
	"menu-button": `CountryCollaboratorList_menu-button__BS5CY`,
	"keywords-title": `CountryCollaboratorList_keywords-title__1495s`,
	"keywords-container": `CountryCollaboratorList_keywords-container__jBNsj`,
	"drawer": `CountryCollaboratorList_drawer__UOagY`,
	"drawer-paper": `CountryCollaboratorList_drawer-paper__VypeL`,
	"drawer-container": `CountryCollaboratorList_drawer-container__6Gb5w`,
	"drawer-header": `CountryCollaboratorList_drawer-header__Uc-qa`,
	"close-button": `CountryCollaboratorList_close-button__6zJCl`,
	"drawer-content": `CountryCollaboratorList_drawer-content__VT3jF`,
	"affiliations-list": `CountryCollaboratorList_affiliations-list__HO3SZ`,
	"affiliation-item": `CountryCollaboratorList_affiliation-item__arREd`,
	"affiliation-item-header": `CountryCollaboratorList_affiliation-item-header__4gCs0`,
	"school-icon": `CountryCollaboratorList_school-icon__9KIqo`,
	"keywords-badge": `CountryCollaboratorList_keywords-badge__NsslO`,
	"keywords-chip": `CountryCollaboratorList_keywords-chip__PMmn-`,
	"affiliation-details": `CountryCollaboratorList_affiliation-details__dipM5`,
	"detail-header": `CountryCollaboratorList_detail-header__OathY`,
	"detail-icon": `CountryCollaboratorList_detail-icon__NkLkH`,
	"detail-title": `CountryCollaboratorList_detail-title__d0VbB`,
	"pub-count": `CountryCollaboratorList_pub-count__P0NsM`,
	"keywords-subtitle": `CountryCollaboratorList_keywords-subtitle__PHo3r`,
	"detail-keywords": `CountryCollaboratorList_detail-keywords__YXyEV`,
	"back-button": `CountryCollaboratorList_back-button__NwzIu`,
	"pub-count-chip": `CountryCollaboratorList_pub-count-chip__EI0kc`,
	"section-title": `CountryCollaboratorList_section-title__yJhNR`,
	"collab-list": `CountryCollaboratorList_collab-list__Zl73t`,
	"collab-item": `CountryCollaboratorList_collab-item__sC-N0`,
	"collab-avatar": `CountryCollaboratorList_collab-avatar__9hETo`,
	"researcher-photo": `CountryCollaboratorList_researcher-photo__TppiL`,
	"unit-logo": `CountryCollaboratorList_unit-logo__z88VV`,
	"avatar-placeholder": `CountryCollaboratorList_avatar-placeholder__TPG0a`
};
export default ___CSS_LOADER_EXPORT___;
